/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FavoriteObjectActionApiModel {
  /**
   * Object ID
   */
  object_id?: string;
  /**
   * Object type
   */
  object_type?: FavoriteObjectActionApiModelObjectTypeEnum;
}
export enum FavoriteObjectActionApiModelObjectTypeEnum {
  Coupon = 'coupon',
  News = 'news',
  Pos = 'pos',
  Loyalty = 'loyalty'
}
